import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { UniqueModel } from "./unique.model";

@Component({
    selector: 'uniques',
    templateUrl: 'uniques.component.html'
})

export class UniquesComponent implements OnChanges {
    @Input() unique: UniqueModel;
    @Input() showUniqueRequestsOverlay: boolean;

    constructor() { }

    ngOnChanges(changes: SimpleChanges): void {
  
    }
}


// WEBPACK FOOTER //
// ./src/app/dashboard/uniques/uniques.component.ts